import { z } from "zod";

export const driversGetResponseSchema = z.array(
  z.object({
    uuid: z.uuid(),
    firstName: z.string(),
    lastName: z.string(),
    analyticCode1: z.string().nullable(),
  }),
);

export type DriversGetResponse = z.infer<typeof driversGetResponseSchema>;
